export default function downloadPdfFromJson(jsonUrl, downloadFilename) {
  fetch(jsonUrl)
    .then((res) => res.json())
    .then((payload) => {
      const binary = atob(payload.data);
      const bytes = new Uint8Array(binary.length);
      for (let i = 0; i < binary.length; i++) {
        bytes[i] = binary.charCodeAt(i);
      }
      const blob = new Blob([bytes], {
        type: payload.contentType || "application/pdf",
      });
      const objectUrl = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = objectUrl;
      link.download = downloadFilename || payload.filename || "documento.pdf";
      document.body.appendChild(link);
      link.click();
      link.remove();
      URL.revokeObjectURL(objectUrl);
    })
    .catch((err) => {
      console.error("Error al descargar PDF desde JSON:", err);
    });
}
